import {localStoreKeys} from "./AuthContext";
import CryptoJs from "crypto-js";

const URL_PRODUCTION = "https://nuevosistema.busmen.net/WS/";
const secretKeys = "+{}awda%$$%)%Gef"
export async function promiseServer(nameFile = null, params = null, test=false) {


      if(test){
            let url_link =nameFile;
            let opciones = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' // Puedes ajustar el tipo de contenido según tus necesidades
                },
                body: JSON.stringify(params)
            };

            return new Promise((res, rej) => {
                  fetch(url_link, opciones)
                      .then(response => response.json())
                      .then(data => res(data))
                      .catch(error => rej(error));
            });
      }else{
            let dataUser = JSON.parse(localStorage.getItem(localStoreKeys.user));
            let url_link = `${URL_PRODUCTION}${nameFile}.php?`;

            if(!!dataUser){
                  url_link = `${url_link}id_usuario=${dataUser.id}&contrasena=${decryptText(dataUser.pwd)}`
                  url_link = !params? url_link:`${url_link}&`
            }

            if (!!params) {
                  for (const [llave, valor] of Object.entries(params)) {
                        url_link = url_link.concat(`${llave}=${valor}&`);
                  }
                  url_link = url_link.slice(0, -1);
            }

            return new Promise((res, rej) => {
                  fetch(url_link)
                      .then(response => response.json())
                      .then(data => res(data))
                      .catch(error => rej(error));
            });

      }


}

export async function requestServer(nameFile = null, params = null, test=false){
      let dataUser = JSON.parse(localStorage.getItem(localStoreKeys.user));
      let url_link = test? nameFile:`${URL_PRODUCTION}${nameFile}.php?`;
      let new_params =null;
      let opciones = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json' // Puedes ajustar el tipo de contenido según tus necesidades
          },
          body: JSON.stringify(params)
      };

      if(!!dataUser){
            new_params = {
                  id_usuario: dataUser.id,
                  contrasena: decryptText(dataUser.pwd),

            }
      }

      if (!!params) {
            new_params ={
                  ...new_params,
                  ...params
            }
      }

      if(!!new_params){
            opciones={
                  ...opciones,
                  body: JSON.stringify(new_params)
            }

      }

      return new Promise((res, rej) => {
            fetch(url_link, opciones)
                .then(response => response.json())
                .then(data => res(data))
                .catch(error => rej(error));
      });
}

export const encryptText = (text) => {
      let ciphertext = CryptoJs.AES.encrypt(text, secretKeys).toString();
      return ciphertext;
};

export const decryptText = (ciphertext) => {
      let bytes = CryptoJs.AES.decrypt(ciphertext, secretKeys);
      let originalText = bytes.toString(CryptoJs.enc.Utf8);
      return originalText;
};